import { Button, Center, Modal, Space, Text } from "@mantine/core";
import { nprogress } from "@mantine/nprogress";
import { IconAlertCircle } from "@tabler/icons-react";
import { useLocation } from "react-router";
import { useSessionStore } from "../../store/session.store";
import { routePaths } from "../../constants/paths";
import { useAuth } from "../../hooks/useAuth";
import { useEffect } from "react";

export default function SessionExpiredModal() {
  const location = useLocation();
  const pathname = location.pathname;

  const { logoutUser } = useAuth();
  const {
    sessionExpiryModalOpened,
    setSessionExpiryModalOpened,
    sessionExpiryDate,
  } = useSessionStore((state) => state);

  const redirectToLogin = () => {
    const url = `${routePaths.login}`;

    const params = new URLSearchParams();
    params.append("callbackUrl", pathname);

    return `${url}?${params.toString()}`;
  };

  useEffect(() => {
    if (sessionExpiryDate) {
      let today = new Date();

      if (new Date(sessionExpiryDate) > today) {
        setSessionExpiryModalOpened(false);
      } else {
        setSessionExpiryModalOpened(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionExpiryDate]);

  if (sessionExpiryModalOpened)
    return (
      <Modal
        opened={sessionExpiryModalOpened}
        onClose={() => setSessionExpiryModalOpened(false)}
        withCloseButton={false}
        closeOnClickOutside={false}
        closeOnEscape={false}
        radius={16}
        shadow="sm"
        zIndex={1000}
      >
        <Center>
          <IconAlertCircle color="red" size={40} />
        </Center>
        <Space h={"sm"} />
        <Text ta={"center"} fw={600} size="xl">
          Session has expired!!
        </Text>
        <Text ta={"center"} fw={500} size="md">
          Please click on the button to log in again.
        </Text>
        <Space h={"xl"} />
        <Button
          onClick={() => {
            nprogress.start();
            let redirectUrl = redirectToLogin();
            logoutUser(redirectUrl);
          }}
          fullWidth
          radius={"md"}
        >
          Log in
        </Button>
      </Modal>
    );

  return null;
}
